import { Component } from "react";
import { TabberButton } from "../../../../common/custom-form/tabber-button.component";
import Icons from "../../../../icon";
import { InventoryConfirmation } from "../../modal/inventory-confirmation.component";
import { TYPE_FUNCTION, ACTION_TYPES } from "../../../../../constants/external-constants";
export class DetailsDataTable extends Component {
    constructor(props){
        super(props);
        this.state={
            showUpdateBtn:false,
            editMode: false,
            dataItem:this.props.datatable,

        }
    }
    ShowUpdateBtn(){
        this.setState({showUpdateBtn:true})
        this.enableEditMode()
    }
    HideUpdateBtn(){

        this.setState({showUpdateBtn:false})     
        this.enableEditMode() 
    }

    enableEditMode = () => {
        this.setState((prevState) => ({
          editMode: !prevState.editMode,
        }));
      };

    enableUpdate(){
        if (typeof this.props.enableUpdate === TYPE_FUNCTION) {
            this.props.enableUpdate(true)
        }
        if (typeof this.props.toggleDropdown === TYPE_FUNCTION) {          
            this.props.toggleDropdown()
        }
        if (typeof this.props.showDetails === TYPE_FUNCTION) {          
            this.props.showDetails(false);
        }       
    }

    render(){       
        return(
            <div className={this.props.classNameWrapper}>
                <table className="details-view-table">
                    <thead>
                        <tr>
                            { this.props.datatable.map((item)=>

                                item.HeaderItem.map((header,key)=>(                                
                                header.name && <th key={key}>
                                        {header.name}
                                    </th>                                
                                ))
                            
                            )}
                            {this.props.haveToggle && 
                                <>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Execute</th>
                                </>
                            }                           
                        </tr>                        
                    </thead>
                   
                    <tbody >
                    { this.props.datatable.map((item)=>

                        item.dataItem.map((dataItem,itemKey)=>(                                   
                            <tr key={itemKey} onClick={this.enableUpdate.bind(this)} className="row-item">
                                {Object.keys(dataItem).map((detail,keyId) => (
                                     this.state.editMode ? (
                                        <td key={keyId}>
                                          <input
                                            type="text"
                                            value={dataItem[detail]}
                                            onChange={(e) => {
                                              // Update this line of code of the actual data source    
                                                const newData = [...this.props.datatable];
                                                newData[itemKey].dataItem[itemKey][detail] = e.target.value;
                                                this.setState({ datatable: newData });                                         
                                            }}
                                          />
                                        </td>
                                      ) : (
                                        <td key={keyId} value={detail} id={keyId} onClick={this.getDataOnTable}>
                                          {dataItem[detail]}
                                        </td>
                                      )
                                ))}
                                {this.props.haveToggle && 
                                    <>
                                        <td>
                                            <TabberButton/>
                                        </td>
                                        <td>
                                            <TabberButton/>
                                        </td>
                                        <td>
                                            <TabberButton/>
                                        </td>
                                    </>                                    
                                }
                                {
                                    (this.props.haveDeleteBtn ||  this.props.haveEditBtn) &&
                                    <td className="edit-btn-container">  
                                        {
                                            this.state.showUpdateBtn ?
                                            <>
                                                <Icons
                                                customClassName="icon-xmark-reg"
                                                name="xmark"
                                                size="20px"
                                                containerClass="icon-circle-plus-container"
                                                onClick={this.HideUpdateBtn.bind(this)}
                                                />   
                                                
                                                <InventoryConfirmation showUpdateBtn={this.state.showUpdateBtn} titleBtn="Update Icon" enableEdit={this.HideUpdateBtn.bind(this)} /> 
                                            </>
                                            :
                                            <>
                                            {this.props.haveDeleteBtn &&
                                                <InventoryConfirmation titleBtn="Delete" />                                              
                                            }                                              
                                        
                                            {this.props.haveEditBtn &&
                                                <Icons
                                                    customClassName="icon-pen-light"
                                                    name="pen-light"
                                                    size="20px"
                                                    containerClass="icon-circle-plus-container"
                                                    onClick={this.ShowUpdateBtn.bind(this)}
                                                />
                                            }  
                                            </>

                                        }
                                                                               
                                    </td>                                     
                                }                                                            
                            </tr>
                        ))

                    )}
                    </tbody>                    
                </table>
                 {/* Delete */}
                 
                 <div className="delete-buttons-container">
                        {this.props.haveExternalDeleteBtn &&
                        this.props.datatable.map((item, index) => (
                            item.dataItem.map((listItem,indexItem)=>
                                <div key={indexItem} className="delete-button-row">                              
                                <InventoryConfirmation titleBtn="Delete" />
                                </div>
                            )
                        ))}
                 </div>
            </div>
        );
    }
}

export class SectionDataTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showUpdateBtn: false,
            editMode: false,
            dataItem: this.props.datatable
        }
    }

    ShowUpdateBtn() {
        this.setState({ showUpdateBtn: true })
        this.enableEditMode()
    }

    HideUpdateBtn() {

        this.setState({ showUpdateBtn: false })
        this.enableEditMode()
    }

    enableEditMode = () => {
        this.setState((prevState) => ({
            editMode: !prevState.editMode,
        }));
    };

    rowClick(index) {
        this.props.rowClickAction(index);
    }

    renderTableDataValue(props, item, c) {
        return item[this.getProp(props.datatable[0].HeaderItem[0], c.name)];
    }

    getProp(columns, name) {
        return Object.entries(columns)
            .filter((x) => {
                return x[1].name === name;
            })
            .map((x) => x[0])[0];
    }

    renderTableData = (item) => {
        return Object.values(this.props.datatable[0].HeaderItem[0]).map((value) => {
            if (!value.hidden) {
                return (
                    <td
                        className="col-text-overflow"
                        key={"td-" + value.name + "-" + Object.keys(value)[0]}
                        hidden={value.hidden}
                    >
                        {this.renderTableDataValue(this.props, item, value)}
                    </td>
                );
            }

        });
    };

    render() {
        return (
            <div className={this.props.classNameWrapper}>
                <table className="details-view-table">
                    <thead>
                        <tr>
                            {this.props.datatable.map((item) => {

                                return item.HeaderItem.map((header, key) => {
                                    var columns = Object.values(header).sort((a, b) => (a.order - b.order))
                                    return (
                                        columns.map((row, index) => {
                                            return row.hidden == false && <th key={index}>
                                                {row.name}
                                            </th>
                                        })
                                    )
                                })

                            }

                            )}
                            {this.props.haveToggle &&
                                <>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Execute</th>
                                </>
                            }
                        </tr>
                    </thead>

                    <tbody >
                        {this.props.datatable.map((item, index) => {
                            return item.dataItem.map((dataItem, itemKey) => (
                                <tr key={itemKey} onClick={() => this.rowClick(itemKey)} className="row-item">
                                    {
                                        this.state.editMode ? (
                                            this.renderTableData(dataItem)
                                        ) :
                                            this.renderTableData(dataItem)
                                    }
                                    {this.props.haveToggle &&
                                        <>
                                            <td>
                                                <TabberButton />
                                            </td>
                                            <td>
                                                <TabberButton />
                                            </td>
                                            <td>
                                                <TabberButton />
                                            </td>
                                        </>
                                    }
                                    {
                                        (this.props.haveDeleteBtn || this.props.haveEditBtn) &&
                                        <td className="edit-btn-container">
                                            {
                                                this.state.showUpdateBtn ?
                                                    <>
                                                        <Icons
                                                            customClassName="icon-xmark-reg"
                                                            name="xmark"
                                                            size="20px"
                                                            containerClass="icon-circle-plus-container"
                                                            onClick={this.HideUpdateBtn.bind(this)}
                                                        />
                                                        <InventoryConfirmation titleBtn="Update Icon" enableEdit={this.HideUpdateBtn.bind(this)} />
                                                    </>
                                                    :
                                                    <>
                                                        {this.props.haveDeleteBtn &&
                                                            <InventoryConfirmation actionType={this.props.actionType} titleBtn="Delete" action={() => { this.props.deleteAction(index) }} />
                                                        }

                                                        {this.props.haveEditBtn &&
                                                            <Icons
                                                                customClassName="icon-pen-light"
                                                                name="pen-light"
                                                                size="20px"
                                                                containerClass="icon-circle-plus-container"
                                                                onClick={this.ShowUpdateBtn.bind(this)}
                                                            />
                                                        }
                                                    </>

                                            }

                                        </td>
                                    }
                                </tr>
                            )
                            )
                        }
                        )}
                    </tbody>
                </table>
                {/* Delete */}

                <div className="delete-buttons-container">
                    {this.props.haveExternalDeleteBtn &&
                        this.props.datatable.map((item, index) => (
                            item.dataItem.map((listItem, indexItem) =>
                                <div key={indexItem} className="delete-button-row">
                                    <InventoryConfirmation actionType={this.props.actionType} titleBtn={ACTION_TYPES.Delete} confirmAction={() => { this.props.deleteAction(indexItem) }} />
                                </div>
                            )
                        ))}
                </div>
            </div>
        );
    }
}